export const ActiveEnterprisesEmployeesLineGraphData = {
    dateTime:"2021-02-05T19:55:21.979+01:00",
    label:"Business demography by size class (from 2004 onwards, NACE Rev. 2)",
    href:"http://ec.europa.eu/eurostat/wdds/rest/data/v2.1/json/en/bd_9bd_sz_cl_r2?precision=1&indic_sb=V11910&indic_sb=V16910&nace_r2=R91",
    source:"Eurostat",
    updated:"2021-01-18T23:00:00Z",
    extension:{
       datasetId:"bd_9bd_sz_cl_r2",
       lang:"EN",
       description:null,
       subTitle:null
    },
    value:[
       {
          "0":621,
          name:2010,
          "1-4":1645,
          "5-9":1410,
          "GE10":10189,
          TOTAL:13864
       },
       {
          "0":619,
          name:2011,
          "1-4":1796,
          "5-9":1446,
          "GE10":10189,
          TOTAL:14050
       },
       {
          "0":680,
          name:2012,
          "1-4":2188,
          "5-9":1582,
          "GE10":9778,
          TOTAL:14227
       },
       {
          "0":734,
          name:2013,
          "1-4":2289,
          "5-9":1653,
          "GE10":9254,
          TOTAL:13930
       },
       {
          "0":839,
          name:2014,
          "1-4":2362,
          "5-9":1715,
          "GE10":11013,
          TOTAL:15930
       },
       {
          "0":876,
          name:2015,
          "1-4":2554,
          "5-9":1641,
          "GE10":11981,
          TOTAL:17053
       },
       {
          "0":877,
          name:2016,
          "1-4":2223,
          "5-9":1573,
          "GE10":12112,
          TOTAL:16785
       },
       {
          "0":881,
          name:2017,
          "1-4":1876,
          "5-9":1421,
          "GE10":11686,
          TOTAL:15865
       },
       {
          "0":2228,
          name:2018,
          "1-4":2422,
          "5-9":1423,
          "GE10":9331,
          TOTAL:15403
       }
    ],
    graphDimensions:[
       {
          label:"Zero",
          key:"0"
       },
       {
          label:"From 1 to 4 employees",
          key:"1-4"
       },
       {
          label:"From 5 to 9 employees",
          key:"5-9"
       },
       {
          label:"10 employees or more",
          key:"GE10"
       },
       {
          label:"Total",
          key:"TOTAL"
       }
    ],
    dimensions:{
       indic_sb:{
          label:"indic_sb",
          values:{
             "V16910":"Persons employed in the population of active enterprises in t - number"
          }
       },
       "nace_r2":{
          label:"nace_r2",
          values:{
             "R91":"Libraries, archives, museums and other cultural activities"
          }
       },
       sizeclas:{
          label:"sizeclas",
          values:{
             "0":"Zero",
             "1-4":"From 1 to 4 employees",
             "5-9":"From 5 to 9 employees",
             "GE10":"10 employees or more",
             TOTAL:"Total"
          }
       },
       geo:{
          label:"geo",
          values:{
             ES:"Spain"
          }
       },
       time:{
          label:"time",
          values:{
             "2004":"2004",
             "2005":"2005",
             "2006":"2006",
             "2007":"2007",
             "2008":"2008",
             "2009":"2009",
             "2010":"2010",
             "2011":"2011",
             "2012":"2012",
             "2013":"2013",
             "2014":"2014",
             "2015":"2015",
             "2016":"2016",
             "2017":"2017",
             "2018":"2018"
          }
       }
    },
    nuts:{
       "nuts2":"ES",
       label:"Spain"
    }
 }